import { useSnackbar } from "notistack";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import {
  BaseQueryProps,
  BaseSearchQueryProps,
  ListResponseData,
  Material,
  MaterialInput,
} from "../types";
import {
  handleDelete,
  handleDetail,
  handleList,
  handleMutationError,
  handleQueryError,
  handleSave,
  handleSearch,
} from "./handler";

const methods = {
  useSearch: ({ query }: BaseSearchQueryProps) => {
    const navigate = useNavigate();
    return useQuery<Material[]>({
      queryKey: ["materials", query],
      queryFn: () => handleSearch({ baseUrl: "materials", query }),
      onError: handleQueryError(navigate),
    });
  },
  useSave: (materialInput: MaterialInput) => {
    const navigate = useNavigate();
    return useMutation<Material>({
      mutationFn: () =>
        handleSave({ baseUrl: "materials", input: materialInput }),
      onError: handleQueryError(navigate),
      retry: 1,
    });
  },
  useList: ({ order, orderBy, page, query }: BaseQueryProps<Material>) => {
    const navigate = useNavigate();
    return useQuery<ListResponseData<Material>>({
      cacheTime: 0,
      queryKey: ["materials", order, orderBy, page, query],
      queryFn: () =>
        handleList({ baseUrl: "materials", order, orderBy, page, query }),
      onError: handleQueryError(navigate),
    });
  },
  useDetail: (id: string | undefined) => {
    const navigate = useNavigate();
    return useQuery<Material>({
      cacheTime: 0,
      queryKey: ["material", id],
      queryFn: () => handleDetail({ baseUrl: "materials", id }),
      onError: handleQueryError(navigate),
    });
  },
  useDelete: (id?: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation<Material>({
      mutationFn: () => handleDelete({ baseUrl: "materials", id }),
      retry: 1,
      onError: handleMutationError(enqueueSnackbar),
    });
  },
};

export default methods;
